import { Suspense } from "react";
import lazy from "@/utils/lazyWithReload";
import { Navigate, Outlet } from "react-router";

import { SvgIcon } from "@/components/icon";
import { CircleLoading } from "@/components/loading";

import type { AppRouteObject } from "#/router";

const WidgetConfigPage = lazy(() => import("@/pages/configuration/widjetConfiguration/index"));
const DashboardConfigPage = lazy(() => import("@/pages/configuration/dashboardConfiguration/index"));
const DataSourceConfigPage = lazy(() => import("@/pages/configuration/DataSourceConfiguration/index"));
const ExternalLinkPage = lazy(() => import("@/pages/configuration/ExternalLinkConfiguration/index"));
const AIgenPage = lazy(() => import("@/pages/configuration/AiGenerated/index"));
const DashboardManagement = lazy(()=>import("@/pages/configuration/dashboardManagement/index"));
const NewDataSourceConfigPage = lazy(()=>import("@/pages/configuration/NewDataSourceConfiguration/index"));

const configuration: AppRouteObject = {
	order: 3,
	path: "configuration",
	element: (
		<Suspense fallback={<CircleLoading />}>
			<Outlet />
		</Suspense>
	),
	meta: {
		label: "Configuration",
		icon: <SvgIcon icon="ic-menu" className="ant-menu-item-icon" size="24" />,
		key: "/configuration",
	},
	children: [
		{
			index: true,
			element: <Navigate to="widjet-config" replace />,
		},
		{
			path: "widjet-config",
			element: <WidgetConfigPage />,
			meta: { label: "Widget Configuration", key: "/configuration/widjet-config" },
		},
		{
			path: "dashboard-config",
			element: <DashboardConfigPage />,
			meta: { label: "Dashboard Configuration", key: "/configuration/dashboard-config" },
		},
		{
			path: "datasource-config",
			element: <DataSourceConfigPage />,
			meta: { label: "Data Source Configuration", key: "/configuration/datasource-config" },
		},
		{
			path: "new-datasource-config",
			element: <NewDataSourceConfigPage />,
			meta: { label: "New Data Source Configuration", key: "/configuration/new-datasource-config" },
		},
		{
			path: "external-link-config",
			element: <ExternalLinkPage />,
			meta: { label: "External Link Configuration", key: "/configuration/external-link-config" },
		},
		{
			path: "dashboard-management",
			element: <DashboardManagement />,
			meta: { label: "Dashboard Management", key: "/configuration/dashboard-management" },
		},
		// {
		// 	path: "ai-generated-config",
		// 	element: <AIgenPage />,
		// 	meta: { label: "AI Genereted", key: "/configuration/ai-generated-config" },
		// },
		// {
		// 	path: "blog",
		// 	element: <Blog />,
		// 	meta: { label: "sys.menu.blog", key: "/management/blog" },
		// },
	],
};

export default configuration;
